<template>
  <v-data-table
    :items="itens"
    :search="search"
    :headers="headers"
    :fixed-header="true"
    disable-pagination
    hide-default-footer
    :expanded.sync="expanded"
    item-key="comp"
    class="
      torcamento
      table-dashboard-resposivo table-striped
      sticky-column-table
    "
    show-expand
    hide-default-header
  >
    <!-- id="vs-table"
    v-scroll:#vs-table="onScroll" -->
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Comprador</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisa"
          dense
          outlined
          single-line
          hide-details
          clearable
          v-lazy-input:debounce="400"
          class="pr-4 pl-4 search"
        ></v-text-field>
        <v-menu>
          <template v-slot:activator="{ on: menu, attrs }">
            <v-btn
              color="white"
              v-bind="attrs"
              v-on="{ ...menu }"
              height="39px"
              class="mr-4"
            >
              <v-icon color="grey" left>mdi-filter</v-icon>
              {{ ano.text }}
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in selects.ano"
              :key="index"
              @click="menuItem(item)"
            >
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-dialog v-model="dialog" max-width="600">
        <v-card style="border: 1px solid #fff">
          <v-toolbar dark flat color="#042333" height="50px">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title class="subtitle-1"> </v-toolbar-title>
          </v-toolbar>
          <v-card-text
            class="text-uppercase row align-center ma-0"
            style="min-height: 55vh"
          >
            <div class="col-12">
              <p class="text-justify">
                A soma dos valores previsto dos fornecedores ultrapassou o valor
                previsto do comprador
              </p>
              <div>
                <span
                  >VALOR PREVISTO {{ dialogDetalhes.mes }}/{{ ano.text }} PARA
                  {{ dialogDetalhes.comprador }}:</span
                >
                <span class="float-right black--text">
                  R$ {{ dialogDetalhes.comprador_valor }}
                </span>
              </div>
              <div>
                <span
                  >SOMA DOS VALORES PREVISTO DOS FORNECEDORES DE
                  {{ dialogDetalhes.mes }}/{{ ano.text }}</span
                >
                <span class="float-right black--text">
                  R$
                  {{
                    Helpers.formatarValorComCasas(
                      dialogDetalhes.fornecedor_valor,
                      2
                    )
                  }}
                </span>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined text @click="dialog = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template v-slot:header="">
      <thead>
        <tr class="header">
          <th rowspan="2" class="comprador px-2">Comprador / Fornecedor</th>
          <th colspan="3" class="px-2">Total Anual</th>
          <th colspan="4">Jan/{{ ano.text }}</th>
          <th colspan="4">Fev/{{ ano.text }}</th>
          <th colspan="4">Mar/{{ ano.text }}</th>
          <th colspan="4">Abr/{{ ano.text }}</th>
          <th colspan="4">Mai/{{ ano.text }}</th>
          <th colspan="4">Jun/{{ ano.text }}</th>
          <th colspan="4">Jul/{{ ano.text }}</th>
          <th colspan="4">Ago/{{ ano.text }}</th>
          <th colspan="4">Set/{{ ano.text }}</th>
          <th colspan="4">Out/{{ ano.text }}</th>
          <th colspan="4">Nov/{{ ano.text }}</th>
          <th colspan="4">Dez/{{ ano.text }}</th>
        </tr>
        <tr class="subheader">
          <th>Previsto</th>
          <th>Realizado</th>
          <th class="d-none">%</th>
          <th>%</th>
          <th>
            Previsto
            <v-btn class="sort" x-small icon @click="sortField('jan')">
              <v-icon v-if="sort.key == 'jan' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'jan' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th>
            Realizado
            <v-btn class="sort" x-small icon @click="sortField('jan_r')">
              <v-icon v-if="sort.key == 'jan_r' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'jan_r' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th colspan="2">%</th>
          <th>
            Previsto
            <v-btn class="sort" x-small icon @click="sortField('fev')">
              <v-icon v-if="sort.key == 'fev' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'fev' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th>
            Realizado
            <v-btn class="sort" x-small icon @click="sortField('fev_r')">
              <v-icon v-if="sort.key == 'fev_r' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'fev_r' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th colspan="2">%</th>
          <th>
            Previsto
            <v-btn class="sort" x-small icon @click="sortField('mar')">
              <v-icon v-if="sort.key == 'mar' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'mar' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th>
            Realizado
            <v-btn class="sort" x-small icon @click="sortField('mar_r')">
              <v-icon v-if="sort.key == 'mar_r' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'mar_r' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th colspan="2">%</th>
          <th>
            Previsto
            <v-btn class="sort" x-small icon @click="sortField('abr')">
              <v-icon v-if="sort.key == 'abr' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'abr' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th>
            Realizado
            <v-btn class="sort" x-small icon @click="sortField('abr_r')">
              <v-icon v-if="sort.key == 'abr_r' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'abr_r' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th colspan="2">%</th>
          <th>
            Previsto
            <v-btn class="sort" x-small icon @click="sortField('mai')">
              <v-icon v-if="sort.key == 'mai' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'mai' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th>
            Realizado
            <v-btn class="sort" x-small icon @click="sortField('mai_r')">
              <v-icon v-if="sort.key == 'mai_r' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'mai_r' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th colspan="2">%</th>
          <th>
            Previsto
            <v-btn class="sort" x-small icon @click="sortField('jun')">
              <v-icon v-if="sort.key == 'jun' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'jun' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th>
            Realizado
            <v-btn class="sort" x-small icon @click="sortField('jun_r')">
              <v-icon v-if="sort.key == 'jun_r' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'jun_r' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th colspan="2">%</th>
          <th>
            Previsto
            <v-btn class="sort" x-small icon @click="sortField('jul')">
              <v-icon v-if="sort.key == 'jul' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'jul' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th>
            Realizado
            <v-btn class="sort" x-small icon @click="sortField('jul_r')">
              <v-icon v-if="sort.key == 'jul_r' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'jul_r' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th colspan="2">%</th>
          <th>
            Previsto
            <v-btn class="sort" x-small icon @click="sortField('ago')">
              <v-icon v-if="sort.key == 'ago' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'ago' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th>
            Realizado
            <v-btn class="sort" x-small icon @click="sortField('ago_r')">
              <v-icon v-if="sort.key == 'ago_r' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'ago_r' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th colspan="2">%</th>
          <th>
            Previsto
            <v-btn class="sort" x-small icon @click="sortField('set')">
              <v-icon v-if="sort.key == 'set' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'set' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th>
            Realizado
            <v-btn class="sort" x-small icon @click="sortField('set_r')">
              <v-icon v-if="sort.key == 'set_r' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'set_r' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th colspan="2">%</th>
          <th>
            Previsto
            <v-btn class="sort" x-small icon @click="sortField('out')">
              <v-icon v-if="sort.key == 'out' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'out' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th>
            Realizado
            <v-btn class="sort" x-small icon @click="sortField('out_r')">
              <v-icon v-if="sort.key == 'out_r' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'out_r' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th colspan="2">%</th>
          <th>
            Previsto
            <v-btn class="sort" x-small icon @click="sortField('nov')">
              <v-icon v-if="sort.key == 'nov' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'nov' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th>
            Realizado
            <v-btn class="sort" x-small icon @click="sortField('nov_r')">
              <v-icon v-if="sort.key == 'nov_r' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'nov_r' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th colspan="2">%</th>
          <th>
            Previsto
            <v-btn class="sort" x-small icon @click="sortField('dez')">
              <v-icon v-if="sort.key == 'dez' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'dez' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th>
            Realizado
            <v-btn class="sort" x-small icon @click="sortField('dez_r')">
              <v-icon v-if="sort.key == 'dez_r' && sort.order == 1"
                >mdi-chevron-down</v-icon
              >
              <v-icon v-else-if="sort.key == 'dez_r' && sort.order == -1"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
            </v-btn>
          </th>
          <th colspan="2">%</th>
        </tr>
      </thead>
    </template>
    <template v-slot:item="{ item, isExpanded, expand }">
      <tr
        :style="isExpanded ? 'background-color: #f2f2f2;' : ''"
        :class="isExpanded ? 'expand' : ''"
        class="trfor"
      >
        <td class="comprador text-truncate">
          <v-btn @click="expandir(item, expand, isExpanded)" icon>
            <v-icon>
              {{ isExpanded == false ? "mdi-chevron-down" : "mdi-chevron-up" }}
            </v-icon> </v-btn
          >{{ item.comp }}
        </td>
        <td class="text-right">
          {{ item.total }}
        </td>
        <td class="text-right">
          {{ item.total_r }}
        </td>
        <td class="text-center d-none"></td>
        <td class="text-center">
          {{
            Helpers.formatarValorComCasas(
              percentual(item.total_r, item.total),
              2
            )
          }}
        </td>
        <td class="text-right">
          {{ item.jan }}
        </td>
        <td class="tporce text-right" :class="colorClass(item.jan, item.jan_r)">
          {{ item.jan_r }}
        </td>
        <td colspan="2" class="text-center">
          {{
            Helpers.formatarValorComCasas(percentual(item.jan_r, item.jan), 2)
          }}
        </td>
        <td class="text-right">
          {{ item.fev }}
        </td>
        <td class="tporce text-right" :class="colorClass(item.fev, item.fev_r)">
          {{ item.fev_r }}
        </td>
        <td colspan="2" class="text-center">
          {{
            Helpers.formatarValorComCasas(percentual(item.fev_r, item.fev), 2)
          }}
        </td>
        <td class="text-right">
          {{ item.mar }}
        </td>
        <td class="tporce text-right" :class="colorClass(item.mar, item.mar_r)">
          {{ item.mar_r }}
        </td>
        <td colspan="2" class="text-center">
          {{
            Helpers.formatarValorComCasas(percentual(item.mar_r, item.mar), 2)
          }}
        </td>
        <td class="text-right">
          {{ item.abr }}
        </td>
        <td class="tporce text-right" :class="colorClass(item.abr, item.abr_r)">
          {{ item.abr_r }}
        </td>
        <td colspan="2" class="text-center">
          {{
            Helpers.formatarValorComCasas(percentual(item.abr_r, item.abr), 2)
          }}
        </td>
        <td class="text-right">
          {{ item.mai }}
        </td>
        <td class="tporce text-right" :class="colorClass(item.mai, item.mai_r)">
          {{ item.mai_r }}
        </td>
        <td colspan="2" class="text-center">
          {{
            Helpers.formatarValorComCasas(percentual(item.mai_r, item.mai), 2)
          }}
        </td>
        <td class="text-right">
          {{ item.jun }}
        </td>
        <td class="tporce text-right" :class="colorClass(item.jun, item.jun_r)">
          {{ item.jun_r }}
        </td>
        <td colspan="2" class="text-center">
          {{
            Helpers.formatarValorComCasas(percentual(item.jun_r, item.jun), 2)
          }}
        </td>
        <td class="text-right">
          {{ item.jul }}
        </td>
        <td class="tporce text-right" :class="colorClass(item.jul, item.jul_r)">
          {{ item.jul_r }}
        </td>
        <td colspan="2" class="text-center">
          {{
            Helpers.formatarValorComCasas(percentual(item.jul_r, item.jul), 2)
          }}
        </td>
        <td class="text-right">
          {{ item.ago }}
        </td>
        <td class="tporce text-right" :class="colorClass(item.ago, item.ago_r)">
          {{ item.ago_r }}
        </td>
        <td colspan="2" class="text-center">
          {{
            Helpers.formatarValorComCasas(percentual(item.ago_r, item.ago), 2)
          }}
        </td>
        <td class="text-right">
          {{ item.sete }}
        </td>
        <td
          class="tporce text-right"
          :class="colorClass(item.sete, item.set_r)"
        >
          {{ item.set_r }}
        </td>
        <td colspan="2" class="text-center">
          {{
            Helpers.formatarValorComCasas(percentual(item.set_r, item.sete), 2)
          }}
        </td>
        <td class="text-right">
          {{ item.outo }}
        </td>
        <td
          class="tporce text-right"
          :class="colorClass(item.outo, item.out_r)"
        >
          {{ item.out_r }}
        </td>
        <td colspan="2" class="text-center">
          {{
            Helpers.formatarValorComCasas(percentual(item.out_r, item.outo), 2)
          }}
        </td>
        <td class="text-right">
          {{ item.nov }}
        </td>
        <td class="tporce text-right" :class="colorClass(item.nov, item.nov_r)">
          {{ item.nov_r }}
        </td>
        <td colspan="2" class="text-center">
          {{
            Helpers.formatarValorComCasas(percentual(item.nov_r, item.nov), 2)
          }}
        </td>
        <td class="text-right">
          {{ item.dez }}
        </td>
        <td class="tporce text-right" :class="colorClass(item.dez, item.dez_r)">
          {{ item.dez_r }}
        </td>
        <td colspan="2" class="text-center">
          {{
            Helpers.formatarValorComCasas(percentual(item.dez_r, item.dez), 2)
          }}
        </td>
      </tr>
    </template>
    <template v-slot:expanded-item="{ item }">
      <tr v-if="start > 0">
        <td
          :style="'padding-top:' + startHeight + 'px'"
          style="border: 0 !important"
        ></td>
      </tr>
      <tr class="expandido" v-for="(d, k) in item.detalhes" :key="k">
        <!-- v-for="(d, k) in detalhesLimited(item.detalhes)" -->

        <td class="comprador pl-2 text-truncate">
          {{ d.comp }}
        </td>
        <td class="text-right">
          {{ d.total }}
        </td>
        <td class="text-right">
          {{ d.total_r }}
        </td>
        <td class="text-center d-none"></td>
        <td class="text-center">
          {{
            Helpers.formatarValorComCasas(percentual(d.total, item.total_r), 2)
          }}
        </td>
        <td class="text-right">
          <v-text-field
            v-model="d.jan"
            v-currency="qtde"
            single-line
            hide-details
            @focus="focusIn($event)"
            @blur="qtdeSolicitada(item, d, 1, 'jan')"
            @keydown.esc="esc($event, d, 'jan')"
            @keydown.enter.prevent="focusOut($event)"
            :rules="qtdeRules"
            class="valor_previsto"
          ></v-text-field>
        </td>
        <td class="text-right">
          {{ d.jan_r }}
        </td>
        <td class="text-center tporce" :class="colorClass(d.jan, d.jan_r)">
          {{ Helpers.formatarValorComCasas(percentual(d.jan_r, d.jan), 2) }}
        </td>
        <td class="text-center tporce" style="background-color: #f2f2f2">
          {{
            Helpers.formatarValorComCasas(percentual(d.jan_r, item.jan_r), 2)
          }}
        </td>
        <td class="text-right">
          <v-text-field
            v-model="d.fev"
            v-currency="qtde"
            single-line
            hide-details
            @focus="focusIn($event)"
            @blur="qtdeSolicitada(item, d, 2, 'fev')"
            @keydown.esc="esc($event, d, 'fev')"
            @keydown.enter.prevent="focusOut($event)"
            class="valor_previsto"
          ></v-text-field>
        </td>
        <td class="text-right">
          {{ d.fev_r }}
        </td>
        <td class="text-center tporce" :class="colorClass(d.fev, d.fev_r)">
          {{ Helpers.formatarValorComCasas(percentual(d.fev_r, d.fev), 2) }}
        </td>
        <td class="text-center tporce" style="background-color: #f2f2f2">
          {{
            Helpers.formatarValorComCasas(percentual(d.fev_r, item.fev_r), 2)
          }}
        </td>
        <td class="text-right">
          <v-text-field
            v-model="d.mar"
            v-currency="qtde"
            single-line
            hide-details
            @focus="focusIn($event)"
            @blur="qtdeSolicitada(item, d, 3, 'mar')"
            @keydown.esc="esc($event, d, 'mar')"
            @keydown.enter.prevent="focusOut($event)"
            class="valor_previsto"
          ></v-text-field>
        </td>
        <td class="text-right">
          {{ d.mar_r }}
        </td>
        <td class="text-center tporce" :class="colorClass(d.mar, d.mar_r)">
          {{ Helpers.formatarValorComCasas(percentual(d.mar_r, d.mar), 2) }}
        </td>
        <td class="text-center tporce" style="background-color: #f2f2f2">
          {{
            Helpers.formatarValorComCasas(percentual(d.mar_r, item.mar_r), 2)
          }}
        </td>
        <td class="text-right">
          <v-text-field
            v-model="d.abr"
            v-currency="qtde"
            single-line
            hide-details
            @focus="focusIn($event)"
            @blur="qtdeSolicitada(item, d, 4, 'abr')"
            @keydown.esc="esc($event, d, 'abr')"
            @keydown.enter.prevent="focusOut($event)"
            class="valor_previsto"
          ></v-text-field>
        </td>
        <td class="text-right">
          {{ d.abr_r }}
        </td>
        <td class="text-center tporce" :class="colorClass(d.abr, d.abr_r)">
          {{ Helpers.formatarValorComCasas(percentual(d.abr_r, d.abr), 2) }}
        </td>
        <td class="text-center tporce" style="background-color: #f2f2f2">
          {{
            Helpers.formatarValorComCasas(percentual(d.abr_r, item.abr_r), 2)
          }}
        </td>
        <td class="text-right">
          <v-text-field
            v-model="d.mai"
            v-currency="qtde"
            single-line
            hide-details
            @focus="focusIn($event)"
            @blur="qtdeSolicitada(item, d, 5, 'mai')"
            @keydown.esc="esc($event, d, 'mai')"
            @keydown.enter.prevent="focusOut($event)"
            class="valor_previsto"
          ></v-text-field>
        </td>
        <td class="text-right">
          {{ d.mai_r }}
        </td>
        <td class="text-center tporce" :class="colorClass(d.mai, d.mai_r)">
          {{ Helpers.formatarValorComCasas(percentual(d.mai_r, d.mai), 2) }}
        </td>
        <td class="text-center tporce" style="background-color: #f2f2f2">
          {{
            Helpers.formatarValorComCasas(percentual(d.mai_r, item.mai_r), 2)
          }}
        </td>
        <td class="text-right">
          <v-text-field
            v-model="d.jun"
            v-currency="qtde"
            single-line
            hide-details
            @focus="focusIn($event)"
            @blur="qtdeSolicitada(item, d, 6, 'jun')"
            @keydown.esc="esc($event, d, 'jun')"
            @keydown.enter.prevent="focusOut($event)"
            class="valor_previsto"
          ></v-text-field>
        </td>
        <td class="text-right">
          {{ d.jun_r }}
        </td>
        <td class="text-center tporce" :class="colorClass(d.jun, d.jun_r)">
          {{ Helpers.formatarValorComCasas(percentual(d.jun_r, d.jun), 2) }}
        </td>
        <td class="text-center tporce" style="background-color: #f2f2f2">
          {{
            Helpers.formatarValorComCasas(percentual(d.jun_r, item.jun_r), 2)
          }}
        </td>
        <td class="text-right">
          <v-text-field
            v-model="d.jul"
            v-currency="qtde"
            single-line
            hide-details
            @focus="focusIn($event)"
            @blur="qtdeSolicitada(item, d, 7, 'jul')"
            @keydown.esc="esc($event, d, 'jul')"
            @keydown.enter.prevent="focusOut($event)"
            class="valor_previsto"
          ></v-text-field>
        </td>
        <td class="text-right">
          {{ d.jul_r }}
        </td>
        <td class="text-center tporce" :class="colorClass(d.jul, d.jul_r)">
          {{ Helpers.formatarValorComCasas(percentual(d.jul_r, d.jul), 2) }}
        </td>
        <td class="text-center tporce" style="background-color: #f2f2f2">
          {{
            Helpers.formatarValorComCasas(percentual(d.jul_r, item.jul_r), 2)
          }}
        </td>
        <td class="text-right">
          <v-text-field
            v-model="d.ago"
            v-currency="qtde"
            single-line
            hide-details
            @focus="focusIn($event)"
            @blur="qtdeSolicitada(item, d, 8, 'ago')"
            @keydown.esc="esc($event, d, 'ago')"
            @keydown.enter.prevent="focusOut($event)"
            class="valor_previsto"
          ></v-text-field>
        </td>
        <td class="text-right">
          {{ d.ago_r }}
        </td>
        <td class="text-center tporce" :class="colorClass(d.ago, d.ago_r)">
          {{ Helpers.formatarValorComCasas(percentual(d.ago_r, d.ago), 2) }}
        </td>
        <td class="text-center tporce" style="background-color: #f2f2f2">
          {{
            Helpers.formatarValorComCasas(percentual(d.ago_r, item.ago_r), 2)
          }}
        </td>
        <td class="text-right">
          <v-text-field
            v-model="d.sete"
            v-currency="qtde"
            single-line
            hide-details
            @focus="focusIn($event)"
            @blur="qtdeSolicitada(item, d, 9, 'sete')"
            @keydown.esc="esc($event, d, 'sete')"
            @keydown.enter.prevent="focusOut($event)"
            class="valor_previsto"
          ></v-text-field>
        </td>
        <td class="text-right">
          {{ d.set_r }}
        </td>
        <td class="text-center tporce" :class="colorClass(d.sete, d.set_r)">
          {{ Helpers.formatarValorComCasas(percentual(d.set_r, d.sete), 2) }}
        </td>
        <td class="text-center tporce" style="background-color: #f2f2f2">
          {{
            Helpers.formatarValorComCasas(percentual(d.set_r, item.set_r), 2)
          }}
        </td>
        <td class="text-right">
          <v-text-field
            v-model="d.outo"
            v-currency="qtde"
            single-line
            hide-details
            @focus="focusIn($event)"
            @blur="qtdeSolicitada(item, d, 10, 'outo')"
            @keydown.esc="esc($event, d, 'outo')"
            @keydown.enter.prevent="focusOut($event)"
            class="valor_previsto"
          ></v-text-field>
        </td>
        <td class="text-right">
          {{ d.out_r }}
        </td>
        <td class="text-center tporce" :class="colorClass(d.outo, d.out_r)">
          {{ Helpers.formatarValorComCasas(percentual(d.out_r, d.outo), 2) }}
        </td>
        <td class="text-center tporce" style="background-color: #f2f2f2">
          {{
            Helpers.formatarValorComCasas(percentual(d.out_r, item.out_r), 2)
          }}
        </td>
        <td class="text-right">
          <v-text-field
            v-model="d.nov"
            v-currency="qtde"
            single-line
            hide-details
            @focus="focusIn($event)"
            @blur="qtdeSolicitada(item, d, 11, 'nov')"
            @keydown.esc="esc($event, d, 'nov')"
            @keydown.enter.prevent="focusOut($event)"
            class="valor_previsto"
          ></v-text-field>
        </td>
        <td class="text-right">
          {{ d.nov_r }}
        </td>
        <td class="text-center tporce" :class="colorClass(d.nov, d.nov_r)">
          {{ Helpers.formatarValorComCasas(percentual(d.nov_r, d.nov), 2) }}
        </td>
        <td class="text-center tporce" style="background-color: #f2f2f2">
          {{
            Helpers.formatarValorComCasas(percentual(d.nov_r, item.nov_r), 2)
          }}
        </td>
        <td class="text-right">
          <v-text-field
            v-model="d.dez"
            v-currency="qtde"
            single-line
            hide-details
            @focus="focusIn($event)"
            @blur="qtdeSolicitada(item, d, 12, 'dez')"
            @keydown.esc="esc($event, d, 'dez')"
            @keydown.enter.prevent="focusOut($event)"
            class="valor_previsto"
          ></v-text-field>
        </td>
        <td class="text-right">
          {{ d.dez_r }}
        </td>
        <td class="text-center tporce" :class="colorClass(d.dez, d.dez_r)">
          {{ Helpers.formatarValorComCasas(percentual(d.dez_r, d.dez), 2) }}
        </td>
        <td class="text-center tporce" style="background-color: #f2f2f2">
          {{
            Helpers.formatarValorComCasas(percentual(d.dez_r, item.dez_r), 2)
          }}
        </td>
      </tr>
      <tr v-if="start + perPage < detalhes.length">
        <td
          :style="'padding-top:' + endHeight + 'px'"
          style="border: 0 !important"
        ></td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      search: "",
      expanded: [],
      qtdeRules: [],
      headers: [
        { text: "", value: "comp" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
        { text: "", value: "" },
      ],
      qtde: {
        currency: null,
        distractionFree: false,
        precision: 2,
        allowNegative: false,
        valueAsInteger: false,
        autoDecimalMode: false,
      },
      sort: {
        comprador_id: "",
        order: 1,
        key: "",
      },
      dialog: false,
      dialogDetalhes: {},
      inputFocus: "",
      start: 0,
      timeout: null,
      rowHeight: 34,
      perPage: 20,
      detalhes: [],
    };
  },
  computed: {
    ...mapGetters("orcComprador", ["itens", "selects", "ano"]),
    startHeight() {
      return this.start * this.rowHeight - 34;
    },
    endHeight() {
      return this.rowHeight * (this.detalhes.length - this.start);
    },
  },
  created() {
    this.$store.dispatch("orcComprador/Itens", {
      ano: this.ano,
      dashboard: true,
    });
    this.$store.dispatch("orcComprador/Compradores");
    let start = moment().subtract("2", "years").format("YYYY");
    let end = moment().add("2", "years").format("YYYY");
    this.selects.ano = this.selects.ano.filter(
      (s) => s.value >= start && s.value <= end
    );
  },
  methods: {
    ...mapMutations("orcComprador", ["sortDetalhes"]),
    excluir(item) {
      if (confirm("Deseja remover aplicativo?")) {
        this.$store.dispatch("orcComprador/Delete", {
          ano: item.ano,
          comprador_id: item.comprador_id,
        });
      }
    },
    editar(prop) {
      this.item = prop;
    },
    menuItem(prop) {
      this.$store.dispatch("orcComprador/Itens", {
        ano: prop,
        dashboard: true,
      });
    },
    mItem() {
      this.item = "";
    },
    expandir(prop, expand, isExpanded) {
      this.$data.expanded = [];
      if (!isExpanded && this.sort.comprador_id != prop.comprador_id) {
        this.sort.comprador_id = prop.comprador_id;
      } else {
        this.sort.comprador_id = "";
      }
      if (!isExpanded) {
        this.start = 0;
        this.$store.dispatch(
          "loading/addRequisicao",
          this.$store
            .dispatch("orcComprador/Detalhes", {
              comprador_id: prop.comprador_id,
              detalhes: true,
            })
            .then(() => {
              expand(!isExpanded);
            })
        );
      }
    },
    percentual(a, b) {
      if (!a || !b) return 0;
      a = parseFloat(a.replaceAll(".", "").replace(",", "."));
      b = parseFloat(b.replaceAll(".", "").replace(",", "."));
      if (!a) return 0;
      if (!b) return 0;
      return (a * 100) / b;
    },
    colorClass(a, b) {
      a = parseFloat(a.replaceAll(".", "").replace(",", "."));
      b = parseFloat(b.replaceAll(".", "").replace(",", "."));
      if (a == 0 || b == 0) return;
      return a < b ? "red--text" : "green--text text--darken-1";
    },
    focusIn(e) {
      this.inputFocus = e.target.value;
      e.target.select();
    },
    focusOut(e) {
      e.target.blur();
    },
    esc(e, i, emes) {
      i[emes] = this.inputFocus;
      e.target.blur();
    },
    qtdeSolicitada(i, e, mes, emes) {
      this.qtdeRules = [];
      const { pf } = this;
      if (!e[emes] || e[emes] == this.inputFocus) {
        e[emes] = this.inputFocus;
        return;
      }
      const sum = Object.values(i.detalhes).reduce((t, n) => {
        return t + pf(n[emes]);
      }, 0);

      if (pf(i[emes]) < sum) {
        this.dialog = true;
        this.dialogDetalhes = {
          comprador: i.comp,
          comprador_valor: i[emes],
          fornecedor_valor: sum,
          mes: emes,
        };
        this.itens.find((item) => item.comprador_id == i.comprador_id)[emes] =
          this.fn(sum);
      }
      this.$store.dispatch("orcComprador/FornecedorValorPrevisto", {
        ano: this.ano.value,
        mes: mes,
        total_previsto_compra: e[emes],
        comprador_id: i.comprador_id,
        fornecedor_id: e.fornecedor_id,
      });
    },
    pf(v) {
      return parseFloat(v.replaceAll(".", "").replace(",", "."));
    },
    fn(v) {
      return Intl.NumberFormat("pt-BR", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(v);
    },
    sortField(key) {
      if (this.sort.key == key) {
        this.sort.order = -this.sort.order;
      } else {
        this.sort.order = 1;
        this.sort.key = key;
      }
      this.sortDetalhes(this.sort);
    },
    onScroll(e) {
      this.timeout && clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const { scrollTop } = e.target;
        const rows = Math.ceil(scrollTop / this.rowHeight);
        this.start =
          rows + this.perPage > this.detalhes.length
            ? this.detalhes.length - this.perPage
            : rows;
        this.$nextTick(() => {
          e.target.scrollTop = scrollTop;
        });
      }, 20);
    },
    detalhesLimited(itens) {
      this.detalhes = itens;
      return this.detalhes.slice(this.start, this.perPage + this.start);
    },
  },
};
</script>
<style>
/* #vs-table {
  max-height: calc(100vh - 127px) !important;
  overflow: auto;
}

#vs-table .v-data-table__wrapper {
  height: initial !important;
  overflow-x: hidden !important;
} */
</style>